import { memo } from "react";

import type { Hotel_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import { MagazineMediaPublicationRequest } from "./magazine-media-publication-request";
import { ReferenceArticles } from "../../../_shared/ui";
import { DesignMagazineHeaderAndTab } from "../../../_shared/ui/components/header-and-tab";
import { DesignMagazinePlanListItem } from "../../../_shared/ui/components/list/list-item";

type Props = {
	hotelID: string;
	data: Hotel_DesignPageQuery;
};

export const DesignMagazineAboutHotelListPresenter = memo(({ hotelID, data }: Props) => {
	const { hotel } = data;

	return (
		<FeatureIslandContainer>
			<DesignMagazineHeaderAndTab hotelID={hotelID} />

			<FeatureIslandMainWithBackGround>
				<div>
					<p>マガジン版 「概要」の欄に表示される記事を編集できます。</p>
				</div>
				<DesignMagazinePlanListItem
					searchParams={{ resourceID: undefined, resourceType: "AboutHotel" }}
					hotelID={hotelID}
					id={hotel.id}
					mainKeyVisual={hotel.mainKeyVisual ?? DUMMY_IMAGE.s3Object}
					name={hotel.name ?? ""}
				/>
			</FeatureIslandMainWithBackGround>

			<FeatureIslandMainWithBackGround islandTitle="参考記事">
				<ReferenceArticles />
			</FeatureIslandMainWithBackGround>

			<FeatureIslandMainWithBackGround islandTitle="ギャラリーサイト掲載申請">
				<MagazineMediaPublicationRequest hotelID={hotelID} />
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
});

DesignMagazineAboutHotelListPresenter.displayName = "DesignMagazineAboutHotelList";
